/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmContentAttachmentDetail {
    getFixupPrototypeFunction() { return AwsSsmContentAttachmentDetail.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmContentAttachmentDetail>): AwsSsmContentAttachmentDetail {
        let obj = Object.assign(new AwsSsmContentAttachmentDetail(), model);
        AwsSsmContentAttachmentDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmContentAttachmentDetail>): AwsSsmContentAttachmentDetail {
        if (!model) return null;
        return AwsSsmContentAttachmentDetail.newInstance(<AwsSsmContentAttachmentDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmContentAttachmentDetail) {
        if (!obj) return;

        models.AwsSsmContentAttachmentDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmContentAttachmentDetail): boolean {
        Object.setPrototypeOf(obj, AwsSsmContentAttachmentDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.size === undefined) {
            this.size = 0;
        }
    }

    /**
     * The name of an attachment.
     */
    name: string;

    /**
     * The size of an attachment in bytes.
     */
    size: number;

    /**
     * The cryptographic hash value of the document content.
     */
    hash: string;

    /**
     * The hash algorithm used to calculate the hash value
     */
    hash_type: models.AwsSsmHashType;

    /**
     * The URL location of the attachment content.
     */
    url: string;

}
